var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.85,
    height: 26.842,
    viewBox: "0 0 26.85 26.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4093",
    "data-name": "Rectangle 4093",
    width: 26.85,
    height: 26.842,
    fill: "#ed0027"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9998",
    "data-name": "Group 9998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9997",
    "data-name": "Group 9997",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44319",
    "data-name": "Path 44319",
    d: "M13.449,0A13.421,13.421,0,1,1,0,13.385,13.408,13.408,0,0,1,13.449,0m-.024,1.99A11.431,11.431,0,1,0,24.86,13.409,11.464,11.464,0,0,0,13.425,1.99",
    transform: "translate(0 0)",
    fill: "#ed0027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44320",
    "data-name": "Path 44320",
    d: "M17.712,19.118c-1.036,1.046-2.022,2.049-3.017,3.041a1.77,1.77,0,0,1-.541.393A.976.976,0,0,1,13,22.172a1,1,0,0,1,.154-1.284c.907-.923,1.825-1.834,2.743-2.746.126-.125.279-.221.527-.415-.3-.254-.527-.427-.731-.628q-1.243-1.228-2.472-2.469a1.006,1.006,0,1,1,1.407-1.419c1.022,1.012,2.034,2.034,3.081,3.083.131-.12.251-.22.36-.33.916-.914,1.827-1.832,2.747-2.743a1.021,1.021,0,0,1,1.5-.094,1.009,1.009,0,0,1-.086,1.5c-1.013,1.021-2.034,2.033-3.125,3.122.29.268.566.51.826.768.781.774,1.561,1.55,2.33,2.336a1.01,1.01,0,0,1,.053,1.47.994.994,0,0,1-1.467-.064c-1.033-1.022-2.056-2.055-3.142-3.141",
    transform: "translate(-4.302 -4.301)",
    fill: "#ed0027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.d38e365f8f76cbbf4be906a79c497f25.svg";
export { ForwardRef as ReactComponent };